import { Button } from "../core/basic/Button";

const DownloadPDFv2 = ({ url }) => {
  return (
    <Button
      variant={"primary"}
      onPress={() => {
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.target = "_blank";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }}
    >
      Download PDF
    </Button>
  );
};

export default DownloadPDFv2;
